import { IntlKey } from 'locales';
import type { EpicMiddleware } from 'redux-observable';
import { createEpicMiddleware } from 'redux-observable';
import { catchError, startWith } from 'rxjs/operators';
import { errorInEpicAutomaticEmailThunk } from 'state/appCrashed/appCrash.thunks';
import { showNotification } from 'state/notifications/notification.action';
import { UserNotification } from 'state/notifications/notification.model';
import type { EpicWithThunk, ExtraArgument } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { HttpError } from 'utils/http/httpClient.model';

import { isTimeoutError } from './apiErrorEpicHelper';

export function makeEpicMiddleware(extraArgument: ExtraArgument): EpicMiddleware<any, any, AppState, ExtraArgument> {
  return createEpicMiddleware<any, any, AppState, ExtraArgument>({
    dependencies: extraArgument,
  });
}

export type SerializableError = Partial<Error> &
  Partial<Pick<HttpError, 'correlationId' | 'status' | 'url'>> & {
    fileName?: string;
    lineNumber?: number;
  };
export function toSerializableError(error: Partial<SerializableError>): SerializableError {
  return {
    message: error?.message,
    fileName: error?.fileName,
    lineNumber: error?.lineNumber,
    name: error?.name,
    stack: error?.stack,
    correlationId: error.correlationId,
    status: error.status,
    url: error.url,
  };
}

export function withAppCrashIfException(name: string, epic: EpicWithThunk): EpicWithThunk {
  return (action$, state$, epicExtraArgument) =>
    epic(action$, state$, epicExtraArgument).pipe(
      // takeUntil(crash$),
      catchError((error, source) => {
        epicExtraArgument.frontLogger.error('error in epic  {@FrontError}', toSerializableError(error));
        if (isTimeoutError(error)) {
          const notification: UserNotification = {
            id: error.message,
            level: 'danger',
            title: { id: error.message as IntlKey, values: { timeInMillis: error.timeout } },
            closeAutomatically: false,
          };
          return source.pipe(startWith(showNotification(notification)));
        }

        // Resubscribe to the source stream
        return source.pipe(
          startWith(
            errorInEpicAutomaticEmailThunk(
              `Uncaught exception in "${name}" Epic. Front Version : "${epicExtraArgument.getFrontVersion()}"`,
              error,
            ),
          ),
        );
      }),
    );
}
